module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/exchange-46c4d6640f00520f89cb14cca77a911b.svg";